<template>
  <div>
    <survey :survey="survey" />
    <div id="surveyResult"></div>
  </div>
</template>

<script>


  import * as Survey from "survey-vue";



  import "survey-vue/survey.css";

  Survey.StylesManager.applyTheme("default");

  export default {
    name: "surveyjs-component",
    data() {



      var surveyValueChanged = function (sender, options) {
        var el = document.getElementById(options.name);
        if(el) {
          el.value = options.value;
        }
      };

      const json = { questions: [
          {type: "text", name: "name", title: "Your name:"},
          {type: "text", name: "email", title: "Your e-mail"},
          { type: "checkbox", name: "car", title: "What car are you driving?", isRequired: true, colCount: 4,
            choices: ["None", "Ford", "Vauxhall", "Volkswagen", "Nissan", "Audi", "Mercedes-Benz", "BMW", "Peugeot", "Toyota", "Citroen"] },
          {
            "type": "boolean",
            "name": "bool",
            "title": "Please answer the question",
            "label": "Are you 21 or older?",
            "isRequired": true
          },
          {
            "type": "imagepicker",
            "name": "choosepicture",
            "title": "What animal would you like to see first ?",
            "choices": [
              {
                "value": "lion",
                "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/lion.jpg"
              }, {
                "value": "giraffe",
                "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/giraffe.jpg"
              }, {
                "value": "panda",
                "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/panda.jpg"
              }, {
                "value": "camel",
                "imageLink": "https://surveyjs.io/Content/Images/examples/image-picker/camel.jpg"
              }
            ]
          },
          {
            type: "multipletext",
            name: "pricelimit",
            title: "What is the... ",
            colCount: 2,
            items: [
              {
                name: "mostamount",
                title: "Most amount you would every pay for a product like ours"
              }, {
                name: "leastamount",
                title: "The least amount you would feel comfortable paying"
              }
            ]
          },
          {
            type: "file",
            title: "Please upload your photo",
            name: "image",
            storeDataAsText: false,
            showPreview: true,
            imageWidth: 150,
            maxSize: 102400
          }
        ]};
      const survey = new Survey.Model(json);


      survey
        .onComplete
        .add(function (result) {
          document
            .querySelector('#surveyResult')
            .textContent = "Result JSON:\n" + JSON.stringify(result.data, null, 3);
        });

      survey
        .onValueChanged
        .add(surveyValueChanged);

      survey.data = {
        name: 'John Doe',
        email: 'johndoe@nobody.com',
        car: ['Ford']
      };



      return {
        survey: survey
      };
    }
  };
</script>

<style scoped>
</style>
